/**
 * SMS Verification Page JavaScript
 * Handles SMS verification code submission and resending
 */

(function() {
  'use strict';

  // DOM elements
  const form = document.getElementById('smsVerifyForm');
  const loadingState = document.getElementById('smsLoadingState');
  const errorState = document.getElementById('smsErrorState');
  const formWrapper = document.getElementById('smsFormWrapper');
  const retryButton = document.getElementById('retryButton');
  const verifyDataElement = document.getElementById('smsVerifyData');
  
  // Check if we're on the SMS verify page
  if (!loadingState) {
    return;
  }

  // Get data from Liquid
  let shouldSendSMS = false;
  let customerIdFromLiquid = '';
  let customerPhoneFromLiquid = '';
  
  if (verifyDataElement) {
    shouldSendSMS = verifyDataElement.dataset.shouldSendSms === 'true';
    customerIdFromLiquid = verifyDataElement.dataset.customerId || '';
    customerPhoneFromLiquid = verifyDataElement.dataset.customerPhone || '';
    
    console.log('Verify data from Liquid:', {
      shouldSendSMS,
      customerId: customerIdFromLiquid,
      phone: customerPhoneFromLiquid
    });
  }

  // Read consent params from URL
  const urlParams = new URLSearchParams(window.location.search);
  const smsConsent = urlParams.get('sms') === '1';
  const loyaltyConsent = urlParams.get('loyalty') === '1';
  
  console.log('Consent params:', { smsConsent, loyaltyConsent });

  // Polling state
  let pollingInterval = null;
  let pollingTimeout = null;
  let pollingStartTime = null;
  const POLL_INTERVAL = 3000; // 3 seconds
  const POLL_TIMEOUT = 30000; // 30 seconds
  const RESEND_COOLDOWN = 120; // 2 minutes in seconds

  // Form elements (will be accessed after form is shown)
  let codeInput;
  let verifyButton;
  let resendButton;
  let errorMessage;
  let successMessage;
  let resendTimer;
  let customerIdInput;
  let customerPhoneInput;

  // Rate limiting state
  let resendCooldown = false;
  let cooldownInterval = null;

  /**
   * Poll account data to check if SMS is ready
   */
  async function pollAccountData() {
    try {
      // Try .json extension (Shopify returns text/html)
      const timestamp = new Date().getTime();
      const response = await fetch(`/pages/sms-dogrulama?view=account-data`, {
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });

      // Get response as text first
      const textResponse = await response.text();
      console.log('Poll response (raw):', textResponse.substring(0, 200));
      
      // Parse JSON manually
      let data;
      try {
        data = JSON.parse(textResponse);
      } catch (e) {
        console.error('Failed to parse JSON:', e);
        console.error('Response text:', textResponse);
        throw new Error('Invalid JSON response');
      }
      
      console.log('Poll response (parsed):', data);

      // Check if we got the expected data structure
      if (data.page) {
        // Got Shopify page JSON instead of our custom data
        console.error('Received Shopify page JSON instead of custom data');
        console.error('Make sure page.account-data.liquid template exists and has layout:none');
        throw new Error('Wrong data format');
      }

      // Check if phone_metafield is not empty
      if (data.phone_metafield && data.phone_metafield.trim() !== '') {
        // SMS is ready!
        console.log('SMS ready! Phone:', data.phone_metafield);
        stopPolling();
        showForm(data.phone_metafield);
      } else if (data.duplicate_phone === true || data.duplicate_phone === 'true') {
        // Duplicate phone number detected
        console.error('Duplicate phone number detected');
        stopPolling();
        showDuplicatePhoneError(data.duplicate_phone_message || 'Bu telefon numarası başka bir hesapta kullanılıyor.');
      } else if (data.phone && data.phone.trim() === '') {
        // No phone number in customer note
        console.error('No phone number found in customer note');
        stopPolling();
        showNoPhoneError();
      } else {
        console.log('Waiting for SMS... phone_metafield is empty');
        console.log('Phone from note:', data.phone);
        
        // Check if timeout exceeded
        const elapsed = Date.now() - pollingStartTime;
        if (elapsed >= POLL_TIMEOUT) {
          console.error('Polling timeout exceeded');
          stopPolling();
          showTimeoutError();
        }
      }

    } catch (error) {
      console.error('Polling request failed:', error);
      
      // Check if timeout exceeded
      const elapsed = Date.now() - pollingStartTime;
      if (elapsed >= POLL_TIMEOUT) {
        stopPolling();
        showTimeoutError();
      }
    }
  }

  /**
   * Send SMS verification code
   */
  async function sendSMSCode() {
    console.log('Sending SMS code...');
    
    try {
      const response = await fetch('/apps/sms-verifier/sendVerifyCode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: customerIdFromLiquid,
          sms_consent: smsConsent,
          loyalty_consent: loyaltyConsent
        })
      });

      const data = await response.json();
      console.log('Send SMS response:', data);

      if (!data.success) {
        console.error('SMS send failed:', data.error);
        // Don't show error to user, just continue polling
        // Backend might send SMS later
      } else {
        console.log('SMS sent successfully');
      }

    } catch (error) {
      console.error('Send SMS request failed:', error);
      // Don't show error, just continue polling
    }
  }

  /**
   * Start polling
   */
  function startPolling() {
    console.log('Starting polling...');
    pollingStartTime = Date.now();
    
    // Show loading state
    loadingState.style.display = 'block';
    errorState.style.display = 'none';
    formWrapper.style.display = 'none';
    
    // Poll immediately
    pollAccountData();
    
    // Then poll every 3 seconds
    pollingInterval = setInterval(pollAccountData, POLL_INTERVAL);
    
    // Set timeout to stop after 30 seconds
    pollingTimeout = setTimeout(() => {
      stopPolling();
      showTimeoutError();
    }, POLL_TIMEOUT);
  }

  /**
   * Stop polling
   */
  function stopPolling() {
    console.log('Stopping polling...');
    if (pollingInterval) {
      clearInterval(pollingInterval);
      pollingInterval = null;
    }
    if (pollingTimeout) {
      clearTimeout(pollingTimeout);
      pollingTimeout = null;
    }
  }

  /**
   * Show timeout error state
   */
  function showTimeoutError() {
    loadingState.style.display = 'none';
    errorState.style.display = 'block';
    formWrapper.style.display = 'none';
    
    const errorText = errorState.querySelector('.sms-error-text');
    if (errorText) {
      errorText.textContent = 'SMS gönderilemedi. Lütfen 30 saniye sonra tekrar deneyiniz.';
    }
  }

  /**
   * Show duplicate phone error state
   */
  function showDuplicatePhoneError(message) {
    loadingState.style.display = 'none';
    errorState.style.display = 'block';
    formWrapper.style.display = 'none';
    
    const errorText = errorState.querySelector('.sms-error-text');
    if (errorText) {
      errorText.textContent = message || 'Bu telefon numarası başka bir hesapta kullanılıyor. Lütfen farklı bir numara kullanın veya mevcut hesabınıza giriş yapın.';
    }
    
    // Show link to login page instead of retry
    if (retryButton) {
      retryButton.textContent = 'Giriş Yap';
      retryButton.style.display = 'inline-block';
      retryButton.onclick = () => {
        window.location.href = '/account/login';
      };
    }
  }

  /**
   * Show no phone error state
   */
  function showNoPhoneError() {
    loadingState.style.display = 'none';
    errorState.style.display = 'block';
    formWrapper.style.display = 'none';
    
    const errorText = errorState.querySelector('.sms-error-text');
    if (errorText) {
      errorText.textContent = 'Telefon numaranız kayıtlı değil. Lütfen hesap ayarlarınızdan telefon numaranızı ekleyin.';
    }
    
    // Hide retry button for no phone error
    if (retryButton) {
      retryButton.style.display = 'none';
    }
  }

  /**
   * Show form with phone number
   */
  function showForm(phoneNumber) {
    loadingState.style.display = 'none';
    errorState.style.display = 'none';
    formWrapper.style.display = 'block';
    
    // Show phone number in header
    const phoneDisplay = document.getElementById('phoneNumberDisplay');
    const phoneText = document.getElementById('phoneNumberText');
    if (phoneDisplay && phoneText && phoneNumber) {
      phoneText.textContent = phoneNumber;
      phoneDisplay.style.display = 'block';
    }
    
    // Initialize form elements
    codeInput = document.getElementById('verificationCode');
    verifyButton = document.getElementById('verifyButton');
    resendButton = document.getElementById('resendButton');
    errorMessage = document.getElementById('errorMessage');
    successMessage = document.getElementById('successMessage');
    resendTimer = document.getElementById('resendTimer');
    customerIdInput = document.getElementById('customerId');
    customerPhoneInput = document.getElementById('customerPhone');
    
    // Set phone number
    if (customerPhoneInput) {
      customerPhoneInput.value = phoneNumber;
    }
    
    // Focus on input
    if (codeInput) {
      codeInput.focus();
    }
    
    // Attach event listeners
    if (form) {
      form.addEventListener('submit', handleVerification);
    }
    if (resendButton) {
      resendButton.addEventListener('click', handleResendCode);
    }
    if (codeInput) {
      codeInput.addEventListener('input', handleCodeInput);
    }
    
    console.log('Form initialized with phone:', phoneNumber);
  }

  /**
   * Retry button handler
   */
  if (retryButton) {
    retryButton.addEventListener('click', function() {
      console.log('Retrying...');
      // Show retry button again
      retryButton.style.display = 'inline-block';
      startPolling();
    });
  }

  // Start polling on page load
  if (shouldSendSMS && customerIdFromLiquid) {
    // Send SMS first, then start polling
    console.log('Auto-sending SMS on page load...');
    sendSMSCode().then(() => {
      console.log('SMS sent, starting polling...');
      startPolling();
    }).catch((error) => {
      console.error('SMS send error, starting polling anyway:', error);
      startPolling();
    });
  } else {
    // Just start polling (SMS already sent before)
    console.log('Skipping SMS send, starting polling...');
    startPolling();
  }

  /**
   * Show error message
   */
  function showError(message, remainingAttempts = null) {
    hideMessages();
    errorMessage.textContent = message;
    if (remainingAttempts !== null && remainingAttempts > 0) {
      errorMessage.textContent += ` (Kalan deneme hakkı: ${remainingAttempts})`;
    }
    errorMessage.style.display = 'block';
    console.error('SMS Verify Error:', message);
  }

  /**
   * Show success message
   */
  function showSuccess(message) {
    hideMessages();
    successMessage.textContent = message;
    successMessage.style.display = 'block';
    console.log('SMS Verify Success:', message);
  }

  /**
   * Hide all messages
   */
  function hideMessages() {
    errorMessage.style.display = 'none';
    successMessage.style.display = 'none';
  }

  /**
   * Set loading state on verify button
   */
  function setLoading(isLoading) {
    const buttonText = verifyButton.querySelector('.button-text');
    const buttonSpinner = verifyButton.querySelector('.button-spinner');
    
    if (isLoading) {
      verifyButton.disabled = true;
      verifyButton.classList.add('is-loading');
      if (buttonText) buttonText.style.display = 'none';
      if (buttonSpinner) buttonSpinner.style.display = 'inline-block';
    } else {
      verifyButton.disabled = false;
      verifyButton.classList.remove('is-loading');
      if (buttonText) buttonText.style.display = 'inline';
      if (buttonSpinner) buttonSpinner.style.display = 'none';
    }
  }

  /**
   * Start resend cooldown timer
   */
  function startResendCooldown(seconds = RESEND_COOLDOWN) {
    if (!resendButton || !resendTimer) return;
    
    resendCooldown = true;
    resendButton.disabled = true;
    resendButton.classList.add('disabled');
    resendTimer.style.display = 'inline';

    let remainingSeconds = seconds;
    
    function updateTimer() {
      // Format time as mm:ss
      const minutes = Math.floor(remainingSeconds / 60);
      const secs = remainingSeconds % 60;
      const formattedTime = `${minutes}:${secs.toString().padStart(2, '0')}`;
      
      resendTimer.textContent = `(${formattedTime})`;
      remainingSeconds--;

      if (remainingSeconds < 0) {
        clearInterval(cooldownInterval);
        resendCooldown = false;
        resendButton.disabled = false;
        resendButton.classList.remove('disabled');
        resendTimer.style.display = 'none';
        console.log('Resend cooldown ended');
      }
    }

    updateTimer();
    cooldownInterval = setInterval(updateTimer, 1000);
  }

  /**
   * Validate verification code input
   */
  function validateCode(code) {
    if (!code || code.trim() === '') {
      return { valid: false, message: 'Lütfen doğrulama kodunu giriniz.' };
    }
    
    if (!/^\d{6}$/.test(code)) {
      return { valid: false, message: 'Doğrulama kodu 6 haneli olmalıdır.' };
    }
    
    return { valid: true };
  }

  /**
   * Handle verification form submission
   */
  async function handleVerification(e) {
    e.preventDefault();
    hideMessages();

    const code = codeInput.value.trim();
    const customerId = customerIdInput.value;

    console.log('Attempting verification:', { customerId, codeLength: code.length });

    // Validate input
    const validation = validateCode(code);
    if (!validation.valid) {
      showError(validation.message);
      return;
    }

    // Set loading state
    setLoading(true);

    try {
      const response = await fetch('/apps/sms-verifier/verifyCode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: customerId,
          code: code,
          sms_consent: smsConsent,
          loyalty_consent: loyaltyConsent
        })
      });

      const data = await response.json();
      console.log('Verification response:', data);

      if (data.success && data.verified) {
        const successMsg = data.message || 'Telefon numaranız başarıyla doğrulandı! Yönlendiriliyorsunuz...';
        showSuccess(successMsg);
        
        // Redirect after 2 seconds
        setTimeout(() => {
          window.location.href = '/account';
        }, 2000);
        
      } else {
        // Handle error
        const errorMsg = data.error || 'Doğrulama başarısız. Lütfen kodu kontrol edip tekrar deneyiniz.';
        const remainingAttempts = typeof data.remainingAttempts === 'number' ? data.remainingAttempts : null;
        showError(errorMsg, remainingAttempts);
        setLoading(false);
        
        // Clear input for retry
        codeInput.value = '';
        codeInput.focus();
      }

    } catch (error) {
      console.error('Verification request failed:', error);
      showError('Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
      setLoading(false);
    }
  }

  /**
   * Handle resend verification code
   */
  async function handleResendCode(e) {
    e.preventDefault();
    
    if (resendCooldown) {
      console.log('Resend cooldown active');
      return;
    }

    hideMessages();

    const customerId = customerIdInput.value;

    console.log('Resending verification code:', { customerId });

    try {
      const response = await fetch('/apps/sms-verifier/sendVerifyCode', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customerId: customerId,
          sms_consent: smsConsent,
          loyalty_consent: loyaltyConsent
        })
      });

      const data = await response.json();
      console.log('Resend response:', data);

      if (data.success) {
        const successMsg = data.message || 'Yeni doğrulama kodu gönderildi. Lütfen SMS kutunuzu kontrol ediniz.';
        showSuccess(successMsg);
        
        // Use remainingSeconds from backend if available, otherwise default cooldown
        const cooldownSeconds = data.remainingSeconds || RESEND_COOLDOWN;
        startResendCooldown(cooldownSeconds);
      } else {
        const errorMsg = data.error || 'Kod gönderilemedi. Lütfen daha sonra tekrar deneyiniz.';
        
        // If rate limit error, show remaining seconds
        if (data.remainingSeconds) {
          showError(`${errorMsg} (${data.remainingSeconds} saniye)`);
        } else {
          showError(errorMsg);
        }
      }

    } catch (error) {
      console.error('Resend request failed:', error);
      showError('Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.');
    }
  }

  /**
   * Only allow numeric input
   */
  function handleCodeInput(e) {
    // Remove non-numeric characters
    const value = e.target.value.replace(/[^0-9]/g, '');
    e.target.value = value;
  }

  console.log('SMS Verification JS initialized');

})();
